var _rect, _text, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResumeBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Website_button",
    "data-name": "Website button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 31,
    viewBox: "0 0 106 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 106,
    height: 31,
    rx: 5,
    fill: "#f2f2f2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Resume",
    transform: "translate(65 20)",
    fill: "#e0611a",
    fontSize: 12,
    fontFamily: "Poppins-Bold, Poppins",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25,
    y: 0
  }, "Resume"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "website",
    transform: "translate(16 7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M180.229,329.247v5a3,3,0,0,1-3,3h-10a3,3,0,0,1-3-3v-10a3,3,0,0,1,3-3h5",
    transform: "translate(-164.229 -321.247)",
    fill: "none",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M180.229,326.9v-5.653H174.89",
    transform: "translate(-164.229 -321.247)",
    fill: "none",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    y1: 8,
    x2: 8,
    transform: "translate(8)",
    fill: "#fff",
    stroke: "#e0611a",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeBtn);
export default __webpack_public_path__ + "static/media/resume_btn.59376770e77f032b15f843094d3119fd.svg";
export { ForwardRef as ReactComponent };